import React from 'react'
import Grid from '@material-ui/core/Grid'
import { useSelector, useDispatch } from 'react-redux'
import { signOut } from '../../store/actions/authenticationActions'
import Link from '@material-ui/core/Link'
import styled from 'styled-components'

const LoginInOut = () => {
    const dispatch = useDispatch();
    const isLoginTokenValid = useSelector(state => state.authentication.isLoginTokenValid)

    const logout = () => {
        dispatch(signOut(() => {
            window.location.reload()
        }))
    }

    return <div style={{ width: '100%', marginBottom: '10px' }}>
        {
            isLoginTokenValid !== undefined && <Grid container justify="flex-end">
                <Grid item>
                    {isLoginTokenValid ? <StyledLink component="button" onClick={logout}>Sign Out</StyledLink> : <StyledLink href="https://register.tanglewoodresort.club" onClick={(e) => e.preventDefault()} variant="body2">
                        {'variant="body2"'}
                    </StyledLink>}
                </Grid>
            </Grid>
        }
    </div>
}

const StyledLink = styled(Link)`
    cursor : pointer !important;
    text-decoration : none;
    &:hover {
        text-decoration : none; 
    }
`

export default LoginInOut